import { useEffect, useState} from 'react';
import axios from 'axios';
import {getAbbrState, getJobTypeId} from './helpers/helpers.js';



if (typeof window.kw_from_search === 'undefined') window.kw_from_search = "";
if (typeof window.predefined_kw === 'undefined') window.predefined_kw = "";
if (typeof window.predefined_cats === 'undefined') window.predefined_cats = [];
if (typeof window.predefined_job_types === 'undefined') window.predefined_job_types = [];
if (typeof window.predefined_state === 'undefined') window.predefined_state = "";
if (typeof window.predefined_city === 'undefined') window.predefined_city = "";
if (typeof window.jobboard_url === 'undefined') window.jobboard_url = "http://www.slpjobs.com";
//let source = axios.CancelToken.source();

//Query strings used in JungleBoards for targeted pages "View more jobs"

window.params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

if (window.params.kw) window.predefined_kw = window.params.kw;
if (window.params.city) window.predefined_city =window.params.city;
if (window.params.state) window.predefined_state = window.params.state;
if (window.params.category)  window.predefined_cats = window.params.category.split(" "); //In URL, param space comes as a plus
if (window.params.type) {
    window.predefined_job_types = [];
    window.params.type.split("+").forEach((type) => {
        window.predefined_job_types.push(getJobTypeId(type));
    })

}

const useFetchData = (jobParams={}) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    

    

    useEffect(() => {
        //source = axios.CancelToken.source();
        const source = axios.CancelToken.source() // <-- 1st step
        let keywords = jobParams.hasOwnProperty('keywords') ? jobParams['keywords'] : window.kw_from_search;
        const categories = jobParams.hasOwnProperty('categories') ? jobParams['categories'] : null;
        const job_types = jobParams.hasOwnProperty('types') ? jobParams['types'] : null;
        const states = jobParams.hasOwnProperty('states') ? jobParams['states'] : null;
        const cities = jobParams.hasOwnProperty('cities') ? jobParams['cities'] : null;
        const sort_id = jobParams.hasOwnProperty('sort_id') ? jobParams['sort_id'] : null
        const sort_id_qs = sort_id !== null && `sort_id=${sort_id}`;
        const search_after_count = jobParams.hasOwnProperty('search_after_count') ?  jobParams['search_after_count'] : null
        const search_after_count_qs = search_after_count !== null && `search_after_count=${search_after_count}`;
        const from = jobParams.hasOwnProperty('from') ? jobParams['from'] : 0;
        const qs_params = [sort_id_qs, search_after_count_qs].filter(Boolean).join('&');
        let sort = [{"modified_at.date": "desc"}]
         
        keywords = (keywords !== null && keywords !== "") ? keywords : window.predefined_kw;

        //console.log("qs_params: " + qs_params)

        const queryParams = (keywords, filters) => {
            let query = {"bool" : {}},
                facet_filter = [{"bool" : {
                    "must" : [{"term": {"job_board_url.enum": window.jobboard_url}}]
                }}]

            if ((keywords !== null && keywords !== "") ) {
                keywords = keywords.replace(/\bor\b/gi, "operating room"); //fixes OR, OR Nurse, OR-RN etc since elastic reserves OR for operators

                query["bool"] = {
                    "must" : [{
                        "multi_match" : {
                            "query" : keywords.trim(),
                            "fields" : ["job_title^3", "job_city^2", "job_description_raw", "job_category", "job_type"],
                            operator: "and"
                        }
                    }]
                }

                sort = [
                    { "_score": { "order": "desc" }},
                    { "modified_at.date":   { "order": "desc",  "mode": "min" }}
                ]
                
                ///if (window.kw_from_search) Object.assign(query["bool"]["must"]["multi_match"], {operator: "and"});
                
            }

            /*
            if (window.predefined_kw !== "") {
                (query["bool"]["must"] ??= []).push({"match": {"job_title": {"query": window.predefined_kw}}}) // dont use .enum here
                
            }
            */
            
            if (states !== null && states.length > 0) {
                facet_filter[0]["bool"]["must"].push({"terms": {"job_state_abbr.enum": states}})
            }
            else if (window.predefined_state !== "") {
                facet_filter[0]["bool"]["must"].push({"terms": {"job_state_abbr.enum": [getAbbrState(window.predefined_state.replaceAll("_", " "))]}})
            }

            if (cities !== null && cities.length > 0) {
                facet_filter.push({"terms": {"job_city.enum": cities}})
            }
            else if (window.predefined_city !== "") {
                facet_filter.push({"terms": {"job_city.enum": [window.predefined_city.replaceAll("_", " ")]}})
            }
           
            if (categories !== null && categories.length > 0) {
                facet_filter.push({"terms": {"job_category.enum": categories}})
            }
            else if (window.predefined_cats.length>0) {
                //use predefined cats
                window.predefined_cats = (typeof(window.predefined_cats) === "string") ? JSON.parse(window.predefined_cats) : window.predefined_cats;
                facet_filter[0]["bool"]["must"].push({"terms": {"job_category_id.float": window.predefined_cats}})
            }

            if (job_types !== null && job_types.length > 0) {
                facet_filter.push({"terms": {"job_type.enum": job_types}})
            }
            else if (window.predefined_job_types.length>0) {
                //use predefined cats
                window.predefined_cats = (typeof(window.job_types) === "string") ? JSON.parse(window.predefined_cats) : window.predefined_cats;
                window.predefined_job_types.push(12504); // "Any of these"
                facet_filter[0]["bool"]["must"].push({"terms": {"job_type_id.float": window.predefined_job_types}})
            }

            //facet_filter[0]["bool"]["must"].push({"range": {"modified_at.date": {"gte": "now-31d/d", "lt": "now/d"}}}) //only pull the last 30 days
            facet_filter[0]["bool"]["must"].push({"range": {"modified_at.date": {"gte": "now-31d/d"}}}) //only pull the last 30 days
            
            
            //console.log("THE FACETS: " + JSON.stringify(facet_filter));

            query["bool"]["filter"] = facet_filter;


            console.log("THE QUERY: " + JSON.stringify(query));
            return query;
        }

        const compiledData = {
            "from": from,
            "size": 1000,
            "query": queryParams(keywords),
            "aggs": {
                "job_count": {
                        "value_count" : { "field" : "job_board_url.enum" } 
                },
                "categorieslist": {
                    "terms": { 
                        "field": "job_category.enum",
                        "size": 200,
                        "order": {"_key" : "asc"}
                        }  
                },
                "typelist": {
                    "terms": { 
                        "field": "job_type.enum",
                        "size": 10,
                        "order": {"_key" : "asc"}
                        }  
                },
                "stateslist": {
                        "terms": { 
                            "field": "job_state_abbr.enum",
                            "size": 51,
                            "order": {"_key" : "asc"}
                        },
                        "aggs": {
                            "city-list": {
                            "terms": {
                                "field": "job_city.enum",
                                "size": 200,
                                "order": {"_key" : "asc"}
                            }
                        }
                    }
                }
            },
            "fields": [
                "job_order_id",
                "job_title",
                "job_category_main",
                "job_category",
                "job_category_id",
                "job_type",
                "job_city",
                "job_state_abbr",
                "job_postal",
                "job_description_raw",
                "modified_at"
            ],
            "sort": sort,      
            "_source": false  
        }
        

        console.log("compiledJSONData: " + JSON.stringify(compiledData));
        //console.log("sort_id: " + sort_id);
        

        const fetchData = async (compiledData, qs_params) => {
           
        
            try {

                // https://proxy.sunbeltstaffingjobs.com:4143/post_job_search.php?
                // /wp-content/common/proxy/public/post_job_search.php?

                //console.log('URL: /wp-content/common/proxy/public/post_job_search.php?' + qs_params);
                
                setLoading(true);
                const { data: response } = await axios({
                    method: 'post',
                    url: 'https://proxy.sunbeltstaffingjobs.com:4143/post_job_search.php?' + qs_params,
                    cancelToken: source.token,
                    headers: {
                        'Content-Type' : 'application/json',
                        'Accept': 'Token',
                        "Access-Control-Allow-Origin": "*",
                    },
                    data: JSON.stringify(compiledData)
                });
                setData(response);
                //console.log("the response: " +  response);
            } 
            catch (error) {
                let e = error;

                if(axios.isCancel(error)) {
                    // Handle if request was cancelled
                    console.log('Request canceled', error.message);
                }
                else {
                    if (error.response) {
                        e = error.response.data;                
                        if (error.response.data && error.response.data.error) {
                            e = error.response.data.error;        
                        }
                    } 
                    else if (error.message) {
                        e = error.message;
                    } 
                    else {
                        e = "Unknown error occured";
                    }
                    console.error("there was an error: " + e)
                }
                
            }
            finally {
                setLoading(false);
                //if (source) source.cancel("Landing Component got unmounted");
            }
            
            

        };

        fetchData(compiledData, qs_params);

        return () => {
            if (source) source.cancel() // <-- 3rd step
        }

    }, [jobParams]);

    return {data, loading};
};

export default useFetchData;